function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useRouteMatch as routeMatch } from 'react-router-dom';
export var DASHBOARD_PREFIX_URL = '';
export var useRouteMatch = function(arg) {
    if (typeof arg === 'string') {
        return routeMatch("".concat(DASHBOARD_PREFIX_URL).concat(arg));
    } else {
        return routeMatch(_object_spread_props(_object_spread({}, arg), {
            path: "".concat(DASHBOARD_PREFIX_URL).concat(arg.path)
        }));
    }
};
export var uppercaseFirstChar = function(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
export var convertUnderscored = function(text) {
    return typeof text === 'string' ? uppercaseFirstChar(text.toLowerCase().replace(/_/g, ' ')) : '';
};
export var getCroppedImg = function(image, crop, fileName) {
    var canvas = document.createElement('canvas');
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    // As Base64 string
    // const base64Image = canvas.toDataURL('image/jpeg');
    // As a blob
    return new Promise(function(resolve) {
        canvas.toBlob(function(blob) {
            blob.name = fileName;
            resolve(blob);
        }, 'image/jpeg', 1);
    });
};
